/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name export
 * @description
 *
 * # export
 *
 * The `export` module provides export functionality.
 */
angular.module("export", [])
/**
 * @ngdoc service
 * @name exportService
 *
 * @description
 * A export service contains helpers methods related wich export data to the files.
 */
  .service("exportService", function () {

    // save file from any blob of data
    this.saveBlob = function (blob, filename) {
      if(navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var naviBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
        if (angular.isUndefined(naviBlob)) {
          var a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.target = '_blank';
          a.download = filename;
          document.body.appendChild(a);
          a.click();
        } else {
          naviBlob(blob, filename);
        }
      }
    };

  });

})();
